// extracted by mini-css-extract-plugin
export default {"link":"Link_link__oYs4T","no-underline":"Link_no-underline__u8FEQ"};